import { cn } from '@/utils'
import { type PageStatus, pageStatusDotClass } from './pageStatuses'

interface ProcessProps {
  value: number
  max: number
  status?: PageStatus
  title?: string
}

export const Progress = ({
  value,
  max,
  status = 'notStarted',
  title,
}: ProcessProps) => {
  if (value === 0) return null

  return (
    <div
      className={cn('h-full', pageStatusDotClass(status))}
      style={{ width: `${(value / max) * 100}%` }}
      title={title}
    />
  )
}
